import { ID } from "@/data/types/Basic";
import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useReturnRegister } from "@/data/Content/RegisterReturn";
import { useLocalization } from "@/data/Localization";
import { Switch } from '@/utils/switch';
import { ContentProvider } from "@/data/context/content";
import { ReturnAddressCheck } from "./parts/ReturnAddressCheck";
import { SelectReturnProduct } from "./parts/SelectReturnProduct";
import { SelectReturnReason } from "./parts/SelectReturnReason";
import { DownloadReturnOrder } from "./parts/DownloadReturnOrder";
import { ReturnErrorPage } from "./parts/ReturnErrorPage";
import { parseHTML } from "@/utils/parseHTML";

export const ReturnOrder:FC<{id:ID}> = () => {
    const returnValues = useReturnRegister();
    const { returnSteps, activeReturnStep  } = returnValues;
    const returnOrderNLS = useLocalization('ReturnOrder');
    return (
       <ContentProvider value={{ ...returnValues }}> 
            <Box><Stack>{/* <Box>If not registered user, show a back to klanterservice link </Box> */}
                <Typography variant ="h1"> {returnOrderNLS.Main.Heading.t()} </Typography>
                <Typography fontSize={16} sx={{'& a':{textDecoration:'underline'}}}> {parseHTML(returnOrderNLS.Main.SubHeading.t())}  </Typography> 
            </Stack>
               { returnSteps &&  Switch(activeReturnStep )
                    .case(returnSteps.addressCheck, () => <ReturnAddressCheck />)
                    .case(returnSteps.selectProduct, () => <SelectReturnProduct />)
                    .case(returnSteps.selectReason, () => <SelectReturnReason />)
                    .case(returnSteps.downloadReturnForm, () => <DownloadReturnOrder/>)
                    .case(returnSteps.errorPage,()=> <ReturnErrorPage />)
                    .defaultTo(() => null) 
                }      
            </Box>
        </ContentProvider>
    )
}